import { Toaster } from "@bitsentry-ce/components/ui/sonner";
import { useTheme } from "@bitsentry-ce/components/theme";

// The shared toaster reads next-themes, which the dashboard does not use, and
// would follow the OS theme. Toasts follow the dashboard theme instead.
export default function DashboardToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme} />;
}
